module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-LightItalic-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-LightItalic-webfont.svg
// module id = 1633
// module chunks = 0